import { render, staticRenderFns } from "./PingPong.vue?vue&type=template&id=5c9b879d&scoped=true"
import script from "./PingPong.vue?vue&type=script&lang=js"
export * from "./PingPong.vue?vue&type=script&lang=js"
import style0 from "./PingPong.vue?vue&type=style&index=0&id=5c9b879d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9b879d",
  null
  
)

export default component.exports